import React from "react";
import { List } from "../modules/Crops/Tags";

export function CropTagsListPage() {
  return <List />;
}
